<script setup lang="ts">
  import { RouterLink } from 'vue-router';
  import { useNotificationCenter } from './useNotificationCenter';
  import NoticeMessage from '../notice-message/NoticeMessage.vue';
  import type { NotificationDisplay } from '@/shared/lib';

  defineProps<{
    notification: NotificationDisplay;
    isAcknowledgePending?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'acknowledge', id: number): void;
    (e: 'navigate'): void;
  }>();

  const { getRelativeTime } = useNotificationCenter();
</script>

<template>
  <div class="flex w-full flex-col gap-3">
    <p class="text-sm leading-5 text-gray-03">
      <NoticeMessage
        :message="notification.documento"
        :label="notification.hyperlinkLabel"
        :to="notification.navigationRoute"
        @navigate="emit('navigate')"
      />
    </p>
    <p class="text-xs text-gray-03">
      {{ `${notification.formato} • ${getRelativeTime(notification.date)}` }}
    </p>
    <div>
      <button
        v-if="!notification.acknowledged"
        class="inline-flex h-[40px] w-full items-center justify-center rounded-lg bg-[var(--theme-secondary)] px-4 text-sm font-medium text-white shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] transition-opacity disabled:cursor-not-allowed disabled:opacity-70"
        :disabled="isAcknowledgePending"
        @click="emit('acknowledge', notification.id)"
      >
        {{ isAcknowledgePending ? 'Confirmando...' : 'Estou ciente' }}
      </button>
      <RouterLink
        v-else-if="notification.historyRoute"
        :to="notification.historyRoute"
        class="inline-flex h-[40px] w-full items-center justify-center rounded-lg border border-gray-02 bg-white-01 px-4 text-sm font-medium text-gray-07 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] transition-colors hover:bg-gray-09"
        @click="emit('navigate')"
      >
        Ver histórico
      </RouterLink>
    </div>
  </div>
</template>
